import Component from './Component';
import React from 'react';
import {Button} from 'react-bootstrap';
import classNames from 'classnames';

export default class DeleteButton extends Component {

	static contextTypes = {
		user: React.PropTypes.object
	};

	handleClick() {
		if (!this.props.disabled) {
			this.props.onClick();
		}
		else {
			if (this.props.onDisabledClick) {
				this.props.onDisabledClick();
			}
			if (this.props.alert) {
				const alert = new AlertWindow('Oprávnění', this.props.alert);
				alert.show(this.context.store.dispatch);
			}
		}
	}

	render() {
		if (this.props.resource && !this.context.user.isAllowed(this.props.resource, 'delete')) {
			return false;
		}

		return (
			<Button bsStyle="danger"
					className={classNames({'input-group':true, disabled: this.props.disabled})}
					onClick={()=>this.handleClick()}>
				<i className="fa fa-trash-o position-left"></i>Odstranit
			</Button>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/DeleteButton.js